import ROHistoryCardPanelDetail from 'src/components/ROHistoryCard/ROHistoryCardPanel/ROHistoryCardPanelDetail/ROHistoryCardPanelDetail';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    roHistory: state.ROHistory.allRoHistory.roHistory,
    theme: state.Framework.theme,
});

export default connect(mapStateToProps)(ROHistoryCardPanelDetail);